import { THEME_FONTS } from './fonts';
/**
 * Tokens de estilo: valem para a loja inteira e viram variáveis CSS
 * (`apps/shop/src/lib/theme-settings.ts`). As cores e as fontes também chegam ao
 * checkout, ao carrinho e à conta, que são do núcleo.
 *
 * As opções são curadas (escalas fixas, nenhum campo livre de pixel): o lojista mexe,
 * mas dentro do que funciona. Os padrões desenham a loja de antes dos temas.
 */
export const THEME_STYLE_FIELDS = {
    colorPrimary: { type: 'color', label: 'Cor principal', help: 'Botões, preços e destaques.', default: '#3B82F6' },
    colorSecondary: { type: 'color', label: 'Cor secundária', help: 'Rodapé e preço em promoção.', default: '#10B981' },
    colorAccent: { type: 'color', label: 'Cor de destaque', help: 'Selos de desconto.', default: '#F59E0B' },
    colorBackground: { type: 'color', label: 'Cor de fundo', default: '#FFFFFF' },
    colorText: { type: 'color', label: 'Cor do texto', default: '#1F2937' },
    font: { type: 'font', label: 'Fonte do texto', options: THEME_FONTS, default: 'Arial' },
    headingFont: {
        type: 'font',
        label: 'Fonte dos títulos',
        options: THEME_FONTS,
        inheritLabel: 'A mesma do texto',
        default: '',
    },
    headingScale: {
        type: 'select',
        label: 'Tamanho dos títulos',
        options: [
            { value: 'small', label: 'Pequeno' },
            { value: 'normal', label: 'Normal' },
            { value: 'large', label: 'Grande' },
        ],
        default: 'normal',
    },
    corners: {
        type: 'select',
        label: 'Cantos',
        help: 'De cards, imagens e botões.',
        options: [
            { value: 'square', label: 'Retos' },
            { value: 'soft', label: 'Suaves' },
            { value: 'rounded', label: 'Arredondados' },
            { value: 'pill', label: 'Botões em pílula' },
        ],
        default: 'soft',
    },
    spacing: {
        type: 'select',
        label: 'Espaço entre as seções',
        options: [
            { value: 'compact', label: 'Compacto' },
            { value: 'normal', label: 'Normal' },
            { value: 'wide', label: 'Amplo' },
        ],
        default: 'normal',
    },
    buttonStyle: {
        type: 'select',
        label: 'Botões',
        options: [
            { value: 'solid', label: 'Preenchidos' },
            { value: 'outline', label: 'Contorno' },
            { value: 'text', label: 'Só texto' },
        ],
        default: 'solid',
    },
    buttonUppercase: { type: 'toggle', label: 'Texto dos botões em maiúsculas', default: false },
    shadow: {
        type: 'select',
        label: 'Sombra',
        help: 'Em volta dos cards de produto e dos blocos.',
        options: [
            { value: 'none', label: 'Nenhuma' },
            { value: 'soft', label: 'Leve' },
        ],
        default: 'soft',
    },
};
//# sourceMappingURL=style.js.map